import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyUsSection from './components/WhyUsSection';
import ReferencesSection from './components/ReferencesSection';
import FaqSection from './components/FaqSection';
import SeoArticle from './components/SeoArticle';
import CtaBanner from './components/CtaBanner';

export default function HomePage() {
  return (
    <Layout>
      <HeroSection />
      <ServicesSection />
      <WhyUsSection />
      <ReferencesSection />
      <FaqSection />
      <SeoArticle />
      <CtaBanner />
    </Layout>
  );
}
